/**
 * Event object used by the EventEmitter.
 *
 * Each event contains a string name and data. Once created
 * the event is frozen and can't be modified.
 *
 * @export
 * @class FrameworkEvent
 */
export class FrameworkEvent {
    /**
     * Creates an instance of FrameworkEvent.
     * @param {String} name - Event name
     * @param {any} payload - The state of data in the event
     * @param {any} target
     *
     * @memberOf FrameworkEvent
     */
    constructor(name, payload, target) {
        this.data = (payload.data) ? payload.data : payload;
        this.bubbles = (payload.bubbles) ? payload.bubbles : true;

        this.target = target || null;
        this.name = name || 'FrameworkEvent';

        Object.freeze(this);
    }

    /**
     * Returns a copy of the target event.
     *
     * Data is passed by reference and is not copied.
     *
     * @param {any} target
     * @returns {FrameworkEvent}
     *
     * @memberOf FrameworkEvent
     */
    clone(target) {
        const payload = {
            data: this.data,
            bubbles: this.bubbles,
        };
        return new FrameworkEvent(this.name, payload, target);
    }

    /**
     * Upload Progress Event
     *
     * @readonly
     * @static
     *
     * @memberOf FrameworkEvent
     */
    static get UPLOAD_PROGRESS() {
        return 'uploadProgress';
    }

    /**
     * Upload Complete Event
     *
     * @readonly
     * @static
     *
     * @memberOf FrameworkEvent
     */
    static get UPLOAD_COMPLETE() {
        return 'uploadCompete';
    }

    /**
     * HTTP Error Event
     *
     * @readonly
     * @static
     *
     * @memberOf FrameworkEvent
     */
    static get HTTP_ERROR() {
        return 'HTTPError';
    }

    /**
     * HTTP Success Event
     *
     * @readonly
     * @static
     *
     * @memberOf FrameworkEvent
     */
    static get HTTP_SUCCESS() {
        return 'HTTPSuccess';
    }
}

